<div id="errorDialog" class="ziro-do-not-dirty-check" data-automation="error-modal">
  <form #oopsDialogForm="ngForm">
    <div class="modal-header">
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="onClose()"
        data-automation="error-modal-dismiss"
      ></button>
    </div>

    <div class="modal-body text-center" data-automation="error-modal-body">
      @if (state === ModalState.STACKTRACE) {
        <div>
          @if (modalViewProperties.title) {
            <div>
              <h1>
                <i [class]="ziroIcons.ERROR_OOPS" class="fa-2x"></i>
              </h1>
              <h4 id="oopsMessage">
                {{ modalViewProperties.title | translate }}
              </h4>
              <div ng-if="!canSendReport">
                <strong>{{ 'tkey;global.error.contact_admin' | translate }}</strong>
              </div>
              <code>{{ modalViewProperties.errorSummary }}</code>
              @if (modalViewProperties.errorSummary) {
                <br />
              }
              <button
                type="button"
                id="expand-error-dialog"
                class="btn btn-border btn-link"
                [hidden]="!modalViewProperties.stacktrace"
                (click)="modalViewProperties.expanded = !modalViewProperties.expanded"
              >
                @if (modalViewProperties.expanded) {
                  <span>
                    {{ 'tkey;shared.modals.error.hide_details.label' | translate }}
                  </span>
                }
                @if (!modalViewProperties.expanded) {
                  <span>
                    {{ 'tkey;shared.modals.error.show_more.label' | translate }}
                  </span>
                }
              </button>
              <pre
                id="error-dialog-content"
                [hidden]="!(modalViewProperties.expanded && modalViewProperties.stacktrace)"
                [innerHTML]="modalViewProperties.stacktrace | escapeHtml"
              ></pre>
            </div>
          }
        </div>
      }

      @if (state === ModalState.SEND_REPORT) {
        <div>
          <h1>
            <i [class]="ziroIcons.ERROR_OOPS" class="fa-2x"></i>
          </h1>
          <p>{{ 'tkey;shared.modals.error.steps_to_reproduce.label' | translate }}</p>
          <textarea
            id="stepsToReproduce"
            name="stepsToReproduce"
            class="form-control"
            maxlength="900"
            [(ngModel)]="modalViewProperties.stepsToReproduce"
            #stepsToReproduce="ngModel"
          ></textarea>
          @if (stepsToReproduce.invalid && (stepsToReproduce.dirty || stepsToReproduce.touched)) {
            <div>
              @if (stepsToReproduce.errors.maxlength) {
                <div class="text-danger">
                  {{ 'tkey;modals.oops.steps_to_reproduce.too_long.text' | translate }}
                </div>
              }
            </div>
          }
        </div>
      }

      @if (state === ModalState.REPORT_SENT) {
        <div>
          <h1><i [class]="ziroIcons.ERROR_OOPS" class="fa-2x"></i></h1>
          <p>{{ 'tkey;shared.modals.error.report_sent.text' | translate }}</p>
          <pre id="error-dialog-content" data-automation="full-report">{{ modalViewProperties.stepsToReproduce }}</pre>
        </div>
      }
    </div>

    <div class="modal-footer justify-content-center">
      @if (state === ModalState.SEND_REPORT) {
        <div class="text-end" data-automation="error-modal-footer">
          <ziro-button
            [cssClass]="'mt-4'"
            [isDisabled]="!modalViewProperties.stepsToReproduce || modalViewProperties.stepsToReproduce.length < 5"
            [icon]="ziroIcons.VOICEMAIL_SMALL"
            [label]="'tkey;shared.modals.error.send_report.button'"
            (clicked)="sendSupportEmail()"
          ></ziro-button>
        </div>
      }

      @if (state !== ModalState.SEND_REPORT) {
        <div>
          @if (!!currentUser) {
            <ziro-button
              [buttonStyle]="buttonStyles.OUTLINE_INFO"
              [cssClass]="'me-1'"
              [dataAutomation]="'go-home-button'"
              [label]="'tkey;shared.modals.error.go_home.button'"
              (clicked)="onHomeClicked()"
            ></ziro-button>
          }
          @if (canSendReport && state === ModalState.STACKTRACE) {
            <ziro-button
              [label]="'tkey;shared.modals.error.send_report.button'"
              [buttonStyle]="buttonStyles.OUTLINE_PRIMARY"
              [id]="'reportError'"
              [icon]="ziroIcons.VOICEMAIL_SMALL"
              (clicked)="state = ModalState.SEND_REPORT"
            ></ziro-button>
          }
        </div>
      }
    </div>
  </form>
</div>
